import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  computed,
  inject,
  input,
  signal
} from '@angular/core';

@Component({
  selector: 'app-copy-button',
  standalone: true,
  templateUrl: './copy-button.component.html',
  styleUrl: './copy-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CopyButtonComponent {
  readonly value = input.required<string>();
  /** Names what is copied, so the button reads "Copy ID" rather than "Copy". */
  readonly label = input('value');

  readonly copied = signal(false);
  readonly buttonLabel = computed(() => (this.copied() ? 'Copied' : `Copy ${this.label()}`));

  private resetHandle?: ReturnType<typeof setTimeout>;

  constructor() {
    inject(DestroyRef).onDestroy(() => clearTimeout(this.resetHandle));
  }

  async copy(event: MouseEvent): Promise<void> {
    // These sit inside clickable rows, which must not also open on a copy.
    event.stopPropagation();

    try {
      await navigator.clipboard.writeText(this.value());
    } catch {
      // Denied, or no clipboard off a secure origin: say nothing rather than lie.
      return;
    }

    const showCopiedForMs = 1500;
    this.copied.set(true);
    clearTimeout(this.resetHandle);
    this.resetHandle = setTimeout(() => this.copied.set(false), showCopiedForMs);
  }
}
